import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import { FormBox } from '../../css';

const TypeaheadField = ({
  label,
  errors,
  touched,
  name,
  id,
  defaultVal,
  list,
  errorIcon,
  val,
  setFieldValue,
  setFieldTouched,
  required
}) => {
  const [multiple] = useState(false);
  const [selected, setSelected] = useState(
    list.filter(l => l.id === defaultVal)
  );

  const changeHandler = value => {
    setSelected(value);
    setFieldValue(value);
  };
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{required ? `${label}*` : label}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        <Typeahead
          style={{ position: 'relative' }}
          id={id}
          labelKey={val}
          name={name}
          multiple={multiple}
          onChange={changeHandler}
          selected={selected}
          // onInputChange={onInputChange}
          onBlur={setFieldTouched}
          options={list}
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors[name]}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={errorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </FormBox>
  );
};

TypeaheadField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  defaultVal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  list: PropTypes.arrayOf(PropTypes.any).isRequired,
  errorIcon: PropTypes.string.isRequired,
  val: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  required: PropTypes.bool
};

TypeaheadField.defaultProps = {
  required: false,
  defaultVal: null
};

export default TypeaheadField;
